import { global } from ":shared/app";

export type GET = {
  returns: {
    first_name: string;
    last_name: string;
    email: string;
    track: string;
    major: string;
    portfolio: string;
    bio: string;
    image: string;
    team: number | null;
  }[];
};

export const endpoint = "teaming/explore/participants/";

export async function get(): Promise<GET["returns"]> {
  // return Promise.resolve(import("./participants.mocks")).then((r) => {
  //   return r.success;
  // });
  return global.api
    .getAuth(endpoint)
    .then((res) => {
      // res.data[0] = res.data[res.data.length - 1];
      // res.data[1] = res.data[res.data.length - 2];
      return Promise.resolve(res.data);
    })
    .catch((err) => {
      // message: service.api.decode_error(err, "couldn't update password"),
      return Promise.reject(err.message);
    });
}
